import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Skeleton } from 'antd';
import { StoreContext } from '../store/index';

const PrivateRoute = ({ children, adminOnly = false }) => {
  const store = useContext(StoreContext);
  const {
    user: [user],
    isStoreLoading: [isStoreLoading],
  } = store || {};

  const location = useLocation();

  if (isStoreLoading) return <div><Skeleton active /></div>;
  if (!user) return <Navigate to={`/login${location.search}`} replace />;
  if (adminOnly && !user.isAdmin) return <Navigate to="/" replace />;
  return children;
};
export default PrivateRoute;
